import { Link, useLocation } from 'react-router-dom';
import './MobileFooter.css'
import { useEffect } from 'react';
const MobileFooter = () => {
    let location = useLocation();
    const currentRoute = location.pathname;
    
    // Helper function to check if route matches (including sub-routes)
    const isRouteActive = (route) => {
        if (route === '/') {
            return currentRoute === '/';
        }
        return currentRoute.startsWith(route);
    };
  
    useEffect(() => {
      console.log(location.pathname);
    }, [location]);
    return (
<nav className='mobile-footer d-block d-md-none'>
  <div class="nav-box">
    <ul class="nav-container">
      <li class={`nav__item ${isRouteActive('/') && 'active'}`}>
        <Link to="/" class="nav__item-link">
          <div class="nav__item-icon"><ion-icon name="grid-outline"></ion-icon></div>
          <span class="nav__item-text">Dashboard</span>
        </Link>
      </li>
      <li class={`nav__item ${isRouteActive('/mybookings') && 'active'}`}>
        <Link to="/mybookings" class="nav__item-link">
          <div class="nav__item-icon"><ion-icon name="reader-outline"></ion-icon></div>
          <span class="nav__item-text">Bookings</span>
        </Link>
      </li>
      <li class={`nav__item ${isRouteActive('/oneWayAvailabilities') && 'active'}`}>
        <Link to="/oneWayAvailabilities" class="nav__item-link">
          <div class="nav__item-icon"><ion-icon name="navigate-outline"></ion-icon></div>
          <span class="nav__item-text">One-Way</span>
        </Link>
      </li>
      <li class={`nav__item ${isRouteActive('/payments') && 'active'}`}>
        <Link to="/payments" class="nav__item-link">
          <div class="nav__item-icon"><ion-icon name="cash-outline"></ion-icon></div>
          <span class="nav__item-text">Earnings</span>
        </Link>
      </li>
      <li class={`nav__item ${(isRouteActive('/settings') || isRouteActive('/myprofile') || isRouteActive('/cars') || isRouteActive('/drivers') || isRouteActive('/ratings') || isRouteActive('/subscriptions')) && 'active'}`}>
        <Link to="/settings" class="nav__item-link">
          <div class="nav__item-icon"><ion-icon name="ellipsis-horizontal-outline"></ion-icon></div>
          <span class="nav__item-text">More</span>
        </Link>
      </li>
    </ul>
  </div>
</nav>
    )
}
export default MobileFooter